module.exports = __webpack_public_path__ + "static/img/gws_jay.8fe14d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gws_jay.jpg
// module id = wuUS
// module chunks = 1